import React from 'react';

// hooks
import { useDispatch, useSelector } from 'react-redux';

// lodash
import _get from 'lodash-es/get';

// components
import VerificationModal from '../VerificationModal';
import TwoFactor from '../TwoFactor';

// constants
import { SUCCESS_MODAL } from '../../../../actions/uiLogic';

const GlobalPopups = () => {
  /* ************* Verification Modal ************* */
  const dispatch = useDispatch();

  const onContinueClick = () => {
    dispatch({ type: SUCCESS_MODAL.CLEAR });
  };

  /* ************* Two Factor ************* */
  const temp = useSelector(state => state.twofactor);
  const isVisible = _get(temp, 'isVisible', false);

  return (
    <>
      {isVisible && <TwoFactor />}
      <VerificationModal onContinueClick={onContinueClick} />
    </>
  );
};

export default GlobalPopups;
